import { FC, ReactNode } from 'react';
import ContentPage from './ContentTypeBasePage/ContentPage';
import ContentBlock from './ContentTypeBaseBlock/ContentBlock';
import ContentImage from './ContentTypeBaseImage/ContentImage';
import ContentLink from './ContentTypeBaseLink/ContentLink';
import ContentMedia from './ContentTypeBaseMedia/ContentMedia';
import { ContentResponse } from './types/shared';
import { ContentTypeBase } from './types/enums';

interface IContent {
  content: ContentResponse;
}

const Content: FC<IContent> = ({ content }): ReactNode => {
  if (!content)
    return <></>;

  const renderContent = () => {
    switch (content.contentTypeBase) {
      case ContentTypeBase.Link:
        return <ContentLink contentResponse={content} />;
      case ContentTypeBase.Page:
        return <ContentPage contentResponse={content} />;
      case ContentTypeBase.Block:
        return <ContentBlock contentResponse={content} />;
      case ContentTypeBase.Image:
        return <ContentImage contentResponse={content} />;
      case ContentTypeBase.Media:
        return <ContentMedia contentResponse={content} />;
      default:
        console.warn(`Renderingsimplementation saknas för contentTypeBase: ${content.contentTypeBase}`);
        return <></>;
    }
  };

  return renderContent();
};

export default Content;
